import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import routes from "../routes";
import * as authActions from "../actions/auth";
import Preloader from "./Preloader/Preloader";

const AppRouter = (props) => {
  useEffect(() => {
    props.autoLogin();
  }, []);

  const PrivateRoute = ({ Component, ...rest }) => (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!props.authChecked) {
          return <Preloader />;
        }

        if (props.isAuth) {
          return <Component {...routeProps} />;
        }

        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: routeProps.location },
            }}
          />
        );
      }}
    />
  );

  const GuestRoute = ({ Component, ...rest }) => (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!props.authChecked) {
          return <Preloader />;
        }

        if (props.isAuth) {
          return <Redirect to="/shop" />;
        }

        return <Component {...routeProps} />;
      }}
    />
  );

  return (
    <Switch>
      {routes.map((route) => {
        const { path, Component, exact } = route;

        if (route.private) {
          return (
            <PrivateRoute
              key={path}
              path={path}
              exact={exact}
              Component={Component}
            />
          );
        }

        if (route.guest) {
          return (
            <GuestRoute
              key={path}
              path={path}
              exact={exact}
              Component={Component}
            />
          );
        }

        return (
          <Route
            key={path}
            path={path}
            exact={exact}
            component={Component}
          />
        );
      })}

      <Redirect to="/404" />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  isAuth: !!state.auth.authUsername,
  authChecked: state.auth.authChecked,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(authActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);